export default __webpack_public_path__ + "static/media/cp_geo_kw.584cd93f.svg";